<div class="current-station-location-editor" *ngIf="condition" [formGroup]="detailsFormGroup">

    <div class="row">
        <mat-form-field class="flex-grow" appearance="fill">
            <mat-label>
              <sc-dictionary-label dictionaryKey="tmc-yard.ui.admin.filter-administration.details-editor.transport.current-station-location-editor.location"></sc-dictionary-label>
            </mat-label>
            <mat-select formControlName="location" name="location">

                <ng-container *ngFor="let location of locations">
                    <mat-option [value]="location">
                        <sc-dictionary-label dictionaryKey="tmc-yard.ui.admin.filter-administration.details-editor.transport.current-station-location-editor.location.{{location}}"></sc-dictionary-label>
                    </mat-option>
                </ng-container>

            </mat-select>
        </mat-form-field>
    </div>
</div>
